/* eslint-disable jsx-a11y/alt-text */
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Grid,
  IconButton,
} from "@mui/material";
import { AppCSS, Lbl, Spacer, TapButton } from "../../../../components";
import { Prompt } from "../../../../components/dialogue/Dialogue";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import { SFileUpload } from "../../../../components/input/input.styled";
import {
  RowDiv,
  ColDiv,
  UnderlineRowDiv,
} from "../../../../components/misc/misc.styled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FC, useState } from "react";
import { RemoveProject } from "../../../../redux/api";
import { toast } from "react-toastify";
import { Docs, Project } from "../../../../redux/types";

interface DeleteProjectProps {
  onDelete: Function;
  project?: Project;
  docs?: Docs[];
}

export const DeleteProject: FC<DeleteProjectProps> = ({
  project,
  docs,
  onDelete,
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);

  const onTapDelete = async () => {
    if (!project) {
      toast("Project can not delete!", {
        type: "error",
      });
      return;
    }
    setOpenConfirm(false);
    try {
      const status = await RemoveProject(project.id);
      if (status === 200) {
        onDelete();
        toast("Project deleted successfully!", {
          type: "success",
        });
      } else {
        toast("Failed to delete project", {
          type: "error",
        });
      }
    } catch (error) {
      toast("Failed to delete project", {
        type: "error",
      });
    }
  };

  const removeSection = () => {
    return (
      <>
        <UnderlineRowDiv style={{ marginLeft: 20 }}>
          <h2>Danger Zone</h2>
        </UnderlineRowDiv>
        <Spacer size={1} direction="col" />
        <Prompt
          message="Delete complete project?"
          onConfirm={() => onTapDelete()}
          onClose={() => setOpenConfirm(false)}
          open={openConfirm}
        />
        <RowDiv
          style={{
            justifyContent: "flex-start",
            width: "100%",
            marginLeft: 30,
          }}
        >
          <ColDiv
            style={{
              width: "30%",
            }}
          >
            <RowDiv>
              <TapButton
                height={40}
                width={200}
                bgColor={AppCSS.WHITE}
                borderColor={AppCSS.DANGER}
                color={AppCSS.DANGER}
                onTap={() => setOpenConfirm(true)}
                title="Archive Project"
              />
            </RowDiv>
          </ColDiv>
        </RowDiv>
        <Spacer size={1} direction="col" />
      </>
    );
  };

  return removeSection();
};
